// import { Theme } from '@emotion/react';
import { Dispatch, SetStateAction, createContext } from 'react';

export const DarkModeContext = createContext<string>('light');
export const SetDarkModeContext = createContext<
  Dispatch<SetStateAction<string>>
>(() => null);
